"use client";

import { cn } from "@/lib/utils";
import { trans } from "@/service/i18n/i18n";
import { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";

function FaqElement({ title, content }: { title: string; content: string }) {
  const [isActive, setIsActive] = useState(false);
  return (
    <div className={cn("flex flex-col")}>
      <div
        className={
          "flex cursor-pointer items-center justify-between border-b py-4"
        }
        onClick={() => setIsActive(!isActive)}
      >
        <span dangerouslySetInnerHTML={{ __html: title }} />
        {isActive ? (
          <ChevronUpIcon className="h-4 w-4" />
        ) : (
          <ChevronDownIcon className="h-4 w-4" />
        )}
      </div>
      <p
        className={cn("text hidden py-4", isActive && "block")}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
}

export const Faq = ({
  course,
  payments,
}: {
  course: CourseFAQItemVM[];
  payments: CourseFAQItemVM[];
}) => {
  return (
    <div className="flex flex-col gap-8">
      <h2 className="text-lg font-semibold text-zinc-950">FAQ</h2>
      <div>
        <h3 className="text-lg font-semibold">
          {trans("education.course.faq.type.course")}
        </h3>
        {course.map(({ title, content }) => (
          <FaqElement content={content} title={title} key={title} />
        ))}
      </div>

      {payments.length > 0 && (
        <div>
          <h3 className="text-lg font-semibold">
            {trans("education.course.faq.type.payments")}
          </h3>
          {payments.map(({ title, content }) => (
            <FaqElement content={content} title={title} key={title} />
          ))}
        </div>
      )}
    </div>
  );
};
